import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react';
import Api from '../../../../_helpers/Api';

//images
import docIcon from '../../../../assets/img/icons/document.png';
import closeIcon from '../../../../assets/img/icons/close.png';
import loader from '../../../../assets/img/loader.svg';
import { useLanguageContext } from '../../../../_providers/Language';
import { useCurrencyContext } from '../../../../_providers/Currency';
import { trans } from '../../../../_providers/Translation';

function Preferences(props, ref) {

    const langs = useLanguageContext();
    const currencies = useCurrencyContext();

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        data: null,
        timezones: [],
        loading: false,
        onSave: null
    });

    const [validations, setValidations] = useState(null);

    useImperativeHandle(ref, () => ({
        show: data => {
            setPopup(prev => ({
                ...prev,
                loading: false,
                data: data
            }));
            handleShow();
        },
        hide: () => {
            handleHide();
        },
        onSave: fn => {
            setPopup(prev => ({
                ...prev,
                onSave: fn
            }));
        }
    }));

    useEffect(() => {
        Api.get('settings/timezones')
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    timezones: res.data
                }))
            })
    }, []);

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }));

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }));
        }, 50);
    }

    const handleHide = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }));

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }));
        }, 50);
    }

    const handleSave = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            loading: true,
        }));

        setValidations(null);

        let url = 'settings/edit';

        let data = new FormData(e.target);

        Api.post(url, data)
            .then(res => {

                handleHide(e);

                if (typeof popup.onSave === 'function') {
                    popup.onSave();
                }

                document.getElementById("form").reset();

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }));

                let _err = error.response;

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        });
                    }
                }

            });
    }

    const handleInputChange = e => {
        let name = e.target.name.split('[')[1].replace(']', '');
        let val = e.target.value;

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }));
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary small`} onSubmit={handleSave}>
                <h2 className="head">
                    <img src={docIcon} alt="document" className="document-icon" />
                    {trans('labels.terms')}
                    <img src={closeIcon} alt="close" className="close-icon" onClick={handleHide} />
                </h2>


                <div className="popup-container">
                    <div className="col">
                        <label>
                            {trans('labels.language')}
                        </label>

                        <select
                            name="data[lang_id]"
                            value={popup.data && popup.data.lang_id ? popup.data.lang_id : ''}
                            className={validations && validations.lang_id ? 'validate' : ''}
                            onChange={handleInputChange}
                        >
                            <option value=""></option>
                            {langs.map(t =>
                                <option key={'lang-' + t.id} value={t.id}>{t.name}</option>
                            )}
                        </select>
                    </div>
                </div>

                <br />

                <div className="popup-container">
                    <div className="col">
                        <label>
                            {trans('labels.currency')}
                        </label>

                        <select
                            name="data[currency_id]"
                            value={popup.data ? popup.data.currency_id : ''}
                            className={validations && validations.currency_id ? 'validate' : ''}
                            onChange={handleInputChange}
                        >
                            <option value=""></option>
                            {currencies.map(t =>
                                <option key={'c-' + t.id} value={t.id}>{t.name}</option>
                            )}
                        </select>
                    </div>
                </div>

                {/* <br />

                <div className="popup-container">
                    <div className="col">
                        <label>
                            Часова зона
                        </label>

                        <select
                            name="data[tz]"
                            value={popup.data && popup.data.tz ? popup.data.tz : ''}
                            className={validations && validations.tz ? 'validate' : ''}
                            onChange={handleInputChange}
                        >
                            <option value=""></option>
                            {popup.timezones.map((t, i) =>
                                <option key={'tz-' + i} value={t}>{t}</option>
                            )}
                        </select>
                    </div>
                </div> */}

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(Preferences);